import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ReservationForm from "../components/ReservationForm";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import api from "../api/axiosInstance";
import "./ReservationPage.css";

export default function ReservationPage() {
  const [date, setDate] = useState(new Date());
  const [specialOpenDays, setSpecialOpenDays] = useState([]);

  useEffect(() => {
    const fetchSpecialOpenDays = async () => {
      try {
        // Fetch public route (works even when not logged in)
        const { data } = await api.get("/admin/public-special-open");
        setSpecialOpenDays(data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchSpecialOpenDays();
  }, []);

  // Disable all Mondays except special open days
  const isTileDisabled = ({ date: tileDate }) => {
  const day = tileDate.getDay(); // 0 = Sunday, 1 = Monday
  if (day !== 1) return false;

  const tileStr = tileDate.toISOString().split("T")[0];

  // Check if this Monday is a special open day
  const isSpecial = specialOpenDays.some(d => {
    const specialStr = d.date.split("T")[0]; // normalize backend date string
    return tileStr === specialStr;
  });

  return !isSpecial; // disable if not special
};


  return (
    <div id="reservation-page">
      <Navbar />
      <h2>Reserve Your Table</h2>

      <div className="reservation-container">
        {/* Left: Calendar */}
        <div className="reservation-calendar">
          <h3>Select a Date</h3>
          <Calendar
            onChange={setDate}
            value={date}
            minDate={new Date()}
            maxDate={new Date(new Date().setMonth(new Date().getMonth() + 1))}
            tileDisabled={isTileDisabled}
          />
        </div>

        {/* Right: Form */}
        <div className="reservation-form">
          <ReservationForm selectedDate={date} />
        </div>

      </div>
      <Footer/>
    </div>
  );
}
